import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Stack, Table } from "react-bootstrap";
import { useNavigate } from 'react-router-dom'
import inventoryApi from "../api/inventoryApi";

import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader
} from 'react-bs-datatable';
import { Link } from "react-router-dom";

import moment from "moment"
import { isCenterAdmin } from "../utils/userScopeUtil";

const StaffMemberList = () => {


  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  /**
   * RMKM Phase 2 Changes
   * added by @ali 
   * date : 10 April 2025
   * Added filter state & enhanced code to fetch data according to filter 
   * Default staff list: active only (matches Case History behaviour; backend listisactive).
   *  */
  const [filterOption, setFilterOption] = useState({ listisactive: "true" });

  // @Ayush - 11 September 2025, added service category filter
  const [serviceCategory, setServiceCategory] = useState([]);
  const [filteredServiceCategory, setFilteredServiceCategory] = useState([]);

  useEffect(() => {
    getServiceCategory();
  }, []);

  useEffect(() => {
    getStaffMember(filterOption);
    filterServiceCategory();
  }, [filterOption]);

  async function getStaffMember(filters) {
    const result = await inventoryApi.fetchStaffMember(filters);
    if (Array.isArray(result)) {
      setBody(result);
    } else {
      setBody([]);
    }
  }


  async function getServiceCategory() {
    const result = await inventoryApi.fetchServiceArea();
    if (result) {
      setServiceCategory(result);
    }
  }

  const filterServiceCategory = () => {
    if (filterOption?.servicearea) {
      let tempArray = serviceCategory.length && serviceCategory.filter(item => item.servicearea === filterOption.servicearea);
      setFilteredServiceCategory(tempArray);
    } else {
      setFilteredServiceCategory([]);
    }
  }

  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: 'Username', prop: 'username', isFilterable: true,
      cell: (row) => (
        <Link
          to={"/staffmembers/" + row.id}
          state={row}
        >
          {row.username}
        </Link>
      )
    },
    { title: 'Email', prop: 'email', isFilterable: true },
    { title: 'Phone', prop: 'phone', isFilterable: true },
    { title: 'DOB', prop: 'dob', isFilterable: true, cell: (row) => moment(row.dob).format('MM/DD/YYYY'), },
    { title: 'Gender', prop: 'gender', isFilterable: true },
    { title: 'City', prop: 'city', isFilterable: true },
    { title: 'User Role', prop: 'userrole', isFilterable: true },
    { title: 'Service Area', prop: 'servicearea', isFilterable: true },
    // 17-04-2026 Added By Jaseem.
    // Show category label from API (servicecategoryname); fallback to raw id for older responses or missing join.
    // {/* RMKM AMC CHANGES POINT  */}
    {
      title: 'Service Category',
      prop: 'servicecategoryname',
      isFilterable: true,
      cell: (row) => row.servicecategoryname || row.servicecategory || '—',
    },
    { title: 'User Type', prop: 'usertype', isFilterable: true },
    {
      title: "Status",
      prop: "isactive",
      isFilterable: true,
      cell: (row) => (row.isactive ? "Active" : "Inactive"),
    },



  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " "
  }

  const createStaffMember = () => {
    navigate(`/staffmembers/e`);
  }
  /**
   * RMKM Phase 2 Changes
   * added by @ali 
   * date : 10 April 2025
   * Create handler for filter state
   *  */
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === "servicearea") {
      setFilterOption((prev) => ({
        ...prev,
        servicearea: value,
        usertype: "",
        servicecategory: "",
      }));
      return;
    }
    setFilterOption((prev) => ({ ...prev, [name]: value }));
  }

  return (
    <Row className="g-0">
      <Col lg={2} className="mx-2">
        <Link className="nav-link">
          Home <i class="fa-solid fa-chevron-right"></i> Staff Member
        </Link>
      </Col>
      <Col lg={12} className="p-lg-4">
        {body ? (
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 20,
                options: [5, 10, 15, 20],
              },
            }}
          >
            
            {/* Top Row */}
            <Row className="mb-3 align-items-end">
              <Col xs={12} md={4} lg={3}>
                <Filter />
              </Col>

              <Col xs={12} md={3} lg={2}>
                <PaginationOptions labels={labels} />
              </Col>
            </Row>

            {/* Bottom Row */}
            <Row className="mb-4 g-2 align-items-end">
              {!isCenterAdmin() && (
                <>
              <Col xs={12} md={3}>
                <Form.Select
                  name="servicearea"
                  value={filterOption?.servicearea || ""}
                  onChange={handleFilterChange}
                >
                  <option value="">-- Select Branch --</option>
                  <option value="School">School</option>
                  <option value="CBR">CBR</option>
                  <option value="Day Care">Day Care</option>
                </Form.Select>
              </Col>

              <Col xs={12} md={3}>
                <Form.Select
                  name="servicecategory"
                  value={filterOption?.servicecategory || ""}
                  onChange={handleFilterChange}
                  disabled={!filterOption?.servicearea}
                >
                  <option value="">-- Select Category --</option>

                  {filteredServiceCategory?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Col>
                </>
              )}

              <Col xs={12} md={2}>
                <Form.Select
                  name="usertype"
                  value={filterOption?.usertype || ""}
                  onChange={handleFilterChange}
                  disabled={!filterOption?.servicearea}
                >
                  <option value="">-- Select Position --</option>

                  {filterOption?.servicearea === "CBR" &&
                    [
                      "CBR Worker",
                      "CMH",
                      "CMM",
                      "Physiotherapist",
                      "Psychologist",
                      "Speech Therapist",
                      "Vocational Teacher",
                    ].map((value) => (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    ))}

                  {(filterOption?.servicearea === "School" ||
                    filterOption?.servicearea === "Day Care") &&
                    [
                      "Centre In charge",
                      "Special Educator",
                      "Inclusive Teacher",
                      "Physiotherapist",
                      "Psychologist",
                      "Speech Therapist",
                      "Vocational Teacher",
                    ].map((value) => (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    ))}
                </Form.Select>
              </Col>
              <Col xs={12} md={2}>
                <Form.Select
                  name="listisactive"
                  value={filterOption?.listisactive ?? "true"}
                  onChange={handleFilterChange}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                  <option value="">All Staff</option>
                </Form.Select>
              </Col>

              <Col xs={12} md={2} className="d-flex justify-content-md-end">
                <Button
                  variant="outline-primary"
                  className="w-100 w-md-auto"
                  onClick={() => createStaffMember(true)}
                >
                  Create Staff Member
                </Button>
              </Col>
            </Row>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        ) : (
          ""
        )}
      </Col>
      <Col lg={2}></Col>
    </Row>
  );
};

export default StaffMemberList;

